import React, { useState } from 'react';
import CustomerDashboardSidebar from './customerDashboardSidebar';

/**
 * CustomerLayout — shared shell for all customer portal pages.
 * Renders sidebar + header once; every customer page renders only its content inside this wrapper.
 * Manages sidebar collapse state internally so individual pages don't need to.
 */
const CustomerLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-gray-50 font-inter">
      <div className="border-b border-slate-600 bg-slate-800 px-4 py-1.5 text-center text-xs text-slate-200">
        <span className="font-semibold">Alpha Notice:</span> You are using an early-access release. Some features may be limited while we continue improving the experience.
        
      </div>

      <div className="flex min-h-0 flex-1 overflow-hidden">
        <CustomerDashboardSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
        <div className="flex flex-1 flex-col overflow-hidden">
          {/* <CustomerHeader isOpen={sidebarOpen} setIsOpen={setSidebarOpen} /> */}
          <main className="flex-1 overflow-y-auto">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default CustomerLayout;
